import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import get from 'lodash/get';

const pageGQL = gql`
  query Page($id: Int) {
    Page(id: $id) {
      graphQLData
    }
  }
`;

const usePageRehydrate = (pageData) => {
  const { loading, error, data } = useQuery(pageGQL, {
    variables: { id: pageData.foreignId },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  if (!loading && !error && get(data, 'Page.graphQLData')) {
    return Object.assign(pageData, JSON.parse(get(data, 'Page.graphQLData')));
  }

  return pageData;
};

export default usePageRehydrate;
